import React from 'react';
import PropTypes from 'prop-types';
import { isResponseSuccess } from 'helpers';
import { LOGIN } from '../../../constants';
import moment from 'moment';

class EnterMethod extends React.Component {
  static propTypes = {
    deliveryMethod: PropTypes.array.isRequired,
    handleGoback: PropTypes.func.isRequired,
    sendValidationCode: PropTypes.func.isRequired,
    setSendMethod: PropTypes.func.isRequired,
    setExpirationTime: PropTypes.func.isRequired
  }

    state = {
      isSelected: false,
      userName: '',
      deliveryType: '',
      deliveryDestination: ''
    }

    handleChange = (event) => {
      this.setState({
        userName: this.props.deliveryMethod[0].userName,
        deliveryType: event.target.id,
        deliveryDestination: event.target.name,
        isSelected: true
      });
    }

    SubmitMethod = (event) => {
      event.preventDefault();
      const { userName, deliveryType, deliveryDestination } = this.state;
      const payload = {
        userName: userName,
        deliveryType: deliveryType,
        deliveryDestination: deliveryDestination,
        maskedDestination: deliveryDestination.replace(/(.{3})(.*)(?=@)/, '$1•••••')
      };

      const res = this.props.sendValidationCode(payload);
      this.props.setSendMethod(payload);
      this.props.setExpirationTime(moment().add(10, 'minutes'));
      if (!isResponseSuccess(res)) {
        this.setState({
          userNameError: true
        });
      }
    }

    render () {
      const method = this.props.deliveryMethod;

      return (
        <React.Fragment>
          <form className='login-content'>
            <div className='password-container'>
              <div className='login-bold-header'>
              Choose Method Of Delivery
              </div>
              <div className='login-body-text'>
                {LOGIN.METHOD_OF_DELIVERY}
              </div>
              <div className='input-wrapper'>
                {method.map((value, index) =>
                  <label className='radio-button-container' key={index}>
                    {` ${value.deliveryType.toLowerCase()} me at ${value.deliveryDestination.replace(/(.{3})(.*)(?=@)/, '$1•••••')}`}
                    <input type='radio' name={value.deliveryDestination} id={value.deliveryType} onChange={this.handleChange} />
                    <span className='checkmark' />
                  </label>
                )}
              </div>
              <div className='login-body-text login-disclaimer'>
                {LOGIN.MESSAGING_DISCLAIMER}
              </div>
            </div>
            <div className='bottom-button-wrapper'>
              <div>
                <button onClick={this.props.handleGoback} className='login-back-btn' type='reset'>
                   Back
                </button>
              </div>
              <div className=' push'>
                <button
                  disabled={!(this.state.isSelected)}
                  onClick={this.SubmitMethod} className='login-primary-button' type='submit'>
                  Continue
                </button>
              </div>
            </div>
          </form>
        </React.Fragment>
      );
    }
}

export default EnterMethod;
